import { IStaticConfig } from '../typings';

export const brandexpedia: IStaticConfig = {
  isAnimatedLoaderEnabled : false
};
